import { render, staticRenderFns } from "./MoblieProducts.vue?vue&type=template&id=c1057c7e&scoped=true&"
import script from "./MoblieProducts.vue?vue&type=script&lang=js&"
export * from "./MoblieProducts.vue?vue&type=script&lang=js&"
import style0 from "./MoblieProducts.vue?vue&type=style&index=0&id=c1057c7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1057c7e",
  null
  
)

export default component.exports